import { BtnActions, ViewErrors } from '../Types';

export const creditStudyErrors: ViewErrors = {
  ALREADY_EXISTS_AN_ACTIVE_CREDIT_STUDY_FOR_THIS_USER: {
    title: 'Ya tenemos un estudio vigente vinculado a tu documento',
    text: 'Te regresaremos al inicio de este proceso. Por ahora solo debes esperar el resultado de tu aplicación.',
    btnText: 'Revisar documento ingresado',
    btnAction: BtnActions.GO_BACK,
  },
  DEFAULT: {
    title: 'Tuvimos un error inesperado',
    text: 'Algo ocurrió al intentar procesar tu información. Por favor intenta de nuevo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  }
};
